import { ModalHeaderTitle } from "melodies-source/Modal";
import styled from "styled-components";

export const ModalTitle = styled(ModalHeaderTitle)`
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--main-color) !important;
`;
